import { render, staticRenderFns } from "./Kota.vue?vue&type=template&id=c3d8ba64"
import script from "./Kota.vue?vue&type=script&lang=js"
export * from "./Kota.vue?vue&type=script&lang=js"
import style0 from "./Kota.vue?vue&type=style&index=0&id=c3d8ba64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports